// extracted by mini-css-extract-plugin
export default {"ctaWrapper":"v0-z","subtitle":"w0-z","wrapper":"x0-z","leftArrow":"y0-z","rightArrow":"z0-z"};